module.exports = __webpack_public_path__ + "static/media/teams.53495cd6.png";